import { Toaster as HotToaster } from 'react-hot-toast';

export function Toaster() {
  return (
    <HotToaster
      position='bottom-right'
      gutter={8}
      containerClassName='z-[9999]'
      toastOptions={{
        duration: 3000,
        className:
          'rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-sm text-slate-950 shadow-xl shadow-slate-950/10',
        success: {
          className:
            'rounded-lg border border-emerald-200 bg-white px-3 py-2.5 text-sm text-slate-950 shadow-xl shadow-emerald-950/10'
        },
        error: {
          duration: 8000,
          className:
            'max-w-[min(640px,calc(100vw-32px))] overflow-visible rounded-lg border border-red-200 bg-white px-3 py-2.5 text-sm text-slate-950 shadow-xl shadow-red-950/10'
        }
      }}
    />
  );
}
